import { Button } from '@/components/ui/button';
import { Loader2, Sparkles } from 'lucide-react';

type SubmitButtonProps = {
  isSubmitting: boolean;
};

export function SubmitButton({ isSubmitting }: SubmitButtonProps) {
  return (
    <Button type="submit" disabled={isSubmitting} className="w-full h-12 text-lg">
      {isSubmitting ? (
        <>
          <Loader2 className="mr-2 h-5 w-5 animate-spin" />
          Generating...
        </>
      ) : (
        <>
          <Sparkles className="mr-2 h-5 w-5" />
          Generate Itinerary
        </>
      )}
    </Button>
  );
}
